import { ColDef, ICellRendererParams } from 'ag-grid-community'

import { PercentagePoint } from '.'

export const COLUMN_DEFS: ColDef[] = [
  {
    headerName: 'Name',
    field: 'name',
    minWidth: 130,
    flex: 0.8
  },
  {
    headerName: 'Percentage',
    field: 'value',
    minWidth: 110,
    flex: 0.2,
    type: 'rightAligned',
    cellRenderer: ({ data: { value } }: ICellRendererParams<PercentagePoint>) =>
      `${value.toFixed(2)}%`
  }
]

export const DEFAULT_COLUMN_DEFS: ColDef = {
  sortable: true,
  unSortIcon: true
}
